import { SVGProps } from "react";

const SessionIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="icono-activar"
      {...props}
    >
      <rect
        y="0.5"
        width="40"
        height="40"
        rx="5"
        fill={props.fill ?? "#B558F6"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7071 25.9172C26.7058 25.9172 26.705 25.9172 26.7038 25.9172H26.6569C26.6426 25.9211 25.5589 25.9251 24.7344 24.9363C24.5458 24.7039 22.8434 22.6908 21.0838 22.6908H19.0471C17.2875 22.6908 15.585 24.7039 15.4001 24.9284C14.5773 25.9172 13.5087 25.9211 13.474 25.9172H13.4271C13.4283 25.929 12.7736 25.9172 12.3348 25.5075C12.0495 25.2396 11.9018 24.8299 11.8952 24.2863C11.8822 23.2029 12.3266 20.9496 13.1471 17.9439C13.4262 16.9236 14.3862 16.2105 15.4818 16.2105H24.6491C25.7446 16.2105 26.705 16.9236 26.9838 17.9439C27.8042 20.9496 28.2487 23.2029 28.2356 24.2863C28.2173 25.799 27.0593 25.9172 26.7071 25.9172ZM28.5626 17.542C28.0952 15.8284 26.4858 14.6348 24.6491 14.6348H15.4818C13.6454 14.6348 12.036 15.8284 11.5683 17.542C10.9622 19.7639 10.2438 22.7381 10.2626 24.306C10.2744 25.2869 10.5899 26.0708 11.2001 26.6381C12.0662 27.4457 13.1936 27.4929 13.4311 27.4929C13.4409 27.4929 13.4483 27.4929 13.4573 27.4929C13.7458 27.4929 15.4177 27.422 16.6756 25.9133C17.2397 25.2317 18.3483 24.2666 19.0471 24.2666H21.0838C21.783 24.2666 22.8911 25.2317 23.4585 25.9172C24.7136 27.426 26.385 27.4929 26.6736 27.4929C26.683 27.4929 26.6903 27.4929 26.7001 27.4929C26.9373 27.4929 28.065 27.4457 28.9303 26.6381C29.5409 26.0708 29.856 25.2869 29.8683 24.306C29.8875 22.7381 29.1687 19.7639 28.5626 17.542Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6178 18.8453H16.8398V18.0968C16.8398 17.7698 16.5655 17.5059 16.2275 17.5059C15.8892 17.5059 15.6153 17.7698 15.6153 18.0968V18.8453H14.8373C14.499 18.8453 14.2251 19.1092 14.2251 19.4362C14.2251 19.7631 14.499 20.0271 14.8373 20.0271H15.6153V20.7795C15.6153 21.1065 15.8892 21.3704 16.2275 21.3704C16.5655 21.3704 16.8398 21.1065 16.8398 20.7795V20.0271H17.6178C17.9561 20.0271 18.23 19.7631 18.23 19.4362C18.23 19.1092 17.9561 18.8453 17.6178 18.8453Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5744 17.5059C23.236 17.5059 22.9622 17.7698 22.9622 18.0968C22.9622 18.4198 23.236 18.6877 23.5744 18.6877C23.9124 18.6877 24.1866 18.4198 24.1866 18.0968C24.1866 17.7698 23.9124 17.5059 23.5744 17.5059Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5744 20.1895C23.236 20.1895 22.9622 20.4534 22.9622 20.7804C22.9622 21.1073 23.236 21.3713 23.5744 21.3713C23.9124 21.3713 24.1866 21.1073 24.1866 20.7804C24.1866 20.4534 23.9124 20.1895 23.5744 20.1895Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1843 18.8457C21.8459 18.8457 21.572 19.1096 21.572 19.4366C21.572 19.7636 21.8459 20.0275 22.1843 20.0275C22.5222 20.0275 22.7965 19.7636 22.7965 19.4366C22.7965 19.1096 22.5222 18.8457 22.1843 18.8457Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9645 18.8457C24.6262 18.8457 24.3523 19.1096 24.3523 19.4366C24.3523 19.7636 24.6262 20.0275 24.9645 20.0275C25.3025 20.0275 25.5768 19.7636 25.5768 19.4366C25.5768 19.1096 25.3025 18.8457 24.9645 18.8457Z"
        fill="white"
      />
    </svg>
  );
};

export default SessionIcon;
